module.exports = __webpack_public_path__ + "assets/63d0cb9e16e9d7137af1d264ad679e73.svg";